// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconReimbursementsPath = 'M13.494 2a1 1 0 1 0 .002 1.998A1 1 0 0 0 13.494 2Zm0 3.997a2.988 2.988 0 0 1-2.12-.877 3.002 3.002 0 0 1 0-4.243 3.002 3.002 0 0 1 4.241 0 3.002 3.002 0 0 1 0 4.243 2.988 2.988 0 0 1-2.12.877Zm-7-1.998a1 1 0 1 0 .002 1.998A1 1 0 0 0 6.494 4Zm0 3.998a2.988 2.988 0 0 1-2.12-.877 3.002 3.002 0 0 1 0-4.243 3.002 3.002 0 0 1 4.241 0 3.002 3.002 0 0 1 0 4.243 2.988 2.988 0 0 1-2.12.877Zm3 9.002a8.045 8.045 0 0 1-6.498-3.34l.8-1.062a4.004 4.004 0 0 1 3.198-1.598h5.77c-.708 1.073-1.757 2-3.27 2h-1v2h1c2.473 0 4.521-1.577 5.765-4.442.147-.338.5-.558.897-.558h1.276c-.494 3.94-3.866 7-7.938 7ZM.917 14.133a10.048 10.048 0 0 0 8.577 4.866c5.514 0 10-4.486 10-10v-1h-3.338c-.883 0-1.698.378-2.252 1.007l-6.91-.007a6.012 6.012 0 0 0-4.799 2.398L.57 13.555l.347.578Z';
var IconReimbursements = baseIcon('IconReimbursements', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconReimbursementsPath
});
export default IconReimbursements;
//# sourceMappingURL=index.js.map